module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_c('span', {
    staticStyle: {
      "font-size": "19pt"
    }
  }, [_vm._v("A")]), _vm._v("bout the "), _c('span', {
    staticStyle: {
      "font-size": "19pt"
    }
  }, [_vm._v("A")]), _vm._v("uthor")]), _vm._v(" "), _c('p', [_vm._v("Michael Simpson is married to Ellen and lives in Cambridgeshire with his children, Evelyn, Rory and Max. He only started writing during lockdown and "), _c('em', [_vm._v("The")]), _vm._v(" "), _c('em', [_vm._v("Devil’s Ferryman")]), _vm._v(" is his debut novel.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Michael has been a secondary school teacher for over sixteen years and he teaches physical education, history and sociology.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("In his spare time, Michael enjoys keeping fit, playing football and spending time with his family.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0